export const generateMetricCards = (viewSettings, summaryMetrics) => {
    const metricCards = [];
    if (viewSettings.showAccounts) {
        metricCards.push({
            label: "Accounts",
            value: summaryMetrics.accounts,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showPractices) {
        metricCards.push({
            label: "Practices",
            value: summaryMetrics.practices,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showTotalInteractions) {
        metricCards.push({
            label: "Total Interactions",
            value: summaryMetrics.totalInteractions,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showUrgent) {
        metricCards.push({
            label: "Urgent",
            value: summaryMetrics.urgent,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showRoutine) {
        metricCards.push({
            label: "Routine",
            value: summaryMetrics.routine,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showAvgUrgentReadTime) {
        metricCards.push({
            label: "Avg Urgent Read Time",
            value: summaryMetrics.avgUrgentReadTime,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showMedianUrgentReadTime) {
        metricCards.push({
            label: "Median Urgent Read Time",
            value: summaryMetrics.medianUrgentReadTime,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showAvgCallbackTime) {
        metricCards.push({
            label: "Avg Callback Time",
            value: summaryMetrics.avgCallbackTime,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showMedianCallbackTime) {
        metricCards.push({
            label: "Median Callback Time",
            value: summaryMetrics.medianCallbackTime,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showAvgCallbackDuration) {
        metricCards.push({
            label: "Avg Callback Duration",
            value: summaryMetrics.avgCallbackDuration,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showMedianCallbackDuration) {
        metricCards.push({
            label: "Median Callback Duration",
            value: summaryMetrics.medianCallbackDuration,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showCallbackCount) {
        metricCards.push({
            label: "Callback Count",
            value: summaryMetrics.callbackCount,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showVoicemails) {
        metricCards.push({
            label: "Voicemails",
            value: summaryMetrics.voicemails,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showTransfers) {
        metricCards.push({
            label: "Transfers",
            value: summaryMetrics.transfers,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showIsBackup) {
        metricCards.push({
            label: "Is Backup",
            value: summaryMetrics.isBackup,
            color: "var(--text-primary, #333)",
        });
    }
    if (viewSettings.showIsForward) {
        metricCards.push({
            label: "Is Forward",
            value: summaryMetrics.isForward,
            color: "var(--text-primary, #333)",
        });
    }
    return metricCards;
};
//# sourceMappingURL=metricCardsUtils.js.map